<template>
    <div style="height: 100%;">
        <DefaultPageComponent
            :loading="loading"
            :title="'Relatório de ROA'"
            :haveBackButton="true"
            @onBack="$router.push({name: 'dashboard'})"
            :haveContentMargin="true"
        >

        <template #filters>
            <div class="row d-flex justify-content-start align-items-center mt-1">
                <div class="col-2">
                    <div class="form-group">
                        <label for="inputYear">Período</label>
                        <select class="form-control form-control-sm" id="inputYear" style="box-shadow: none; min-height:56px;" v-model="filter.year" :disabled="loading">
                            <option v-for="item in periods" :key="item" :value="item"> {{ item }} </option>
                        </select>
                    </div>
                </div>
                <b-col cols="3" class="d-flex justify-content-start">
                    <GlassButton
                    :loading="loading"
                    @click="search"
                    > 
                        <img src="@/assets/search.png" />
                        Pesquisar
                    </GlassButton>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-end">
                    <CustomButton
                    borderColor="transparent"
                    textColor="#00FF00"
                    @click="showExportModal = true"
                    >
                        Download
                    </CustomButton>
                    
                    <b-modal
                        v-model="showExportModal"
                        title="Formato de exportação"
                        hide-footer
                        centered
                        :body-bg-variant="bodyBgVariant"
                        class="bg-dark"
                        >
                        <div class="d-flex justify-content-around py-3 border rounded bg-black">
                            <b-button
                            variant="outline-success"
                            :pressed="selectedFormat === 'xlsx'"
                            @click="selectedFormat = 'xlsx'"
                            >
                            <b-icon icon="file-earmark-excel" class="mr-2"></b-icon> xlsx
                            </b-button>

                            <b-button
                            variant="outline-danger"
                            :pressed="selectedFormat === 'pdf'"
                            @click="selectedFormat = 'pdf'"
                            >
                            <b-icon icon="file-earmark-pdf" class="mr-2"></b-icon> PDF
                            </b-button>
                        </div>

                        <div class="mt-4 d-flex justify-content-end">
                            <b-button variant="secondary" class="mr-2" @click="showExportModal = false">
                            Cancelar
                            </b-button>
                            <b-button
                            variant="danger"
                            :disabled="!selectedFormat"
                            @click="exportarArquivo"
                            >
                            Exportar
                            </b-button>
                        </div>
                    </b-modal>

                </b-col>
            </div>
        </template>

        <!-- CONTENT -->
        <div class="container" style="padding-left: 150px; padding-right: 150px;">
            <h1 style="font-size: 1.5rem;">ROA {{ filter.year }}</h1>
            <b-table class="custom-table" borderless sticky-header :fields="columns" :items="workingDaysPtax" show-empty empty-text="Sem registros para mostrar no momento...">
                
                <template #cell(actions)="row">
                    <div class="d-flex justify-content-end align-items-center">
                        <b-button 
                            style="width: 39px; height: 40px; background-color: #242323; display: flex; justify-content: center; align-items: center; font-size: 0.875rem; border-color: #535252; box-shadow: none;"
                            @click="showModalEditWorkingDaysPTAX(row.item.id)"
                        >
                            <img src="@/assets/pencil.png" />
                        </b-button>
                    </div>
                </template>
            </b-table>
        </div>

        <template #footer>
            <div></div>
        </template>

        </DefaultPageComponent>

    </div>
</template>

<script>
import DefaultPageComponent from '@/components/DefaultPageComponent.vue';
import GlassButton from '@/components/GlassButton.vue';
import CustomButton from '@/components/CustomButton.vue';

export default {
    name: 'ReportROAView',
    components:{
        DefaultPageComponent,
        GlassButton,
        CustomButton,
    },
    created() {
        this.$validator.localize('en', {
            custom: {
                inputGroupBusinessDays: {
                    required: 'Campo obrigatório.',
                },
            },
        });
    },
    mounted() {
        this.getPeriods();
    },
    data() {
        return {
            loading:false,
            showExportModal: false,
            selectedFormat: null,
            bodyBgVariant: 'dark',
            columns: [
                { key: 'code', label: 'Assessor', class: 'text-right' },
                { key: 'roa_wflow', label: 'ROA WFLOW', class: 'text-right', formatter: value => this.formatDecimal(value) },
                { key: 'roa_pj1', label: 'ROA PJ1', class: 'text-right', formatter: value => this.formatDecimal(value) },
            ],
            workingDaysPtax: [],
            filter: {
                year: '',
            },
            montlyCalendar: {
                id: '',
                year: '',
                month: '',
                business_days: '',
                last_business_day_ptax: '',
                formatted_date: '',
            },
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            periods: [],
        }
    },
    methods: {
        async getPeriods(){
            this.loading = true;
            this.$axios.get('diversifications/periods').then((response) => {
                this.periods = response.data.periods;
                this.filter.year = this.periods[0];
                this.search();
            }).catch(() => {
                return this.$swal({
                    title: 'Erro',
                    text: 'Não foi possível consultar o período.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#C44C30',
                    allowOutsideClick: false,
                });
            })
            .finally(()=>{
                this.loading=false;
            });
        },
        async search() {
            this.loading = true;
            try {
                const response = await this.$axios.get(`advisor-roa?period=${encodeURIComponent(this.filter.year)}`);
                this.workingDaysPtax = response.data;
            } catch (error) {
                this.$swal({
                    title: 'Erro',
                    text: 'Não foi possível carregar os dados do relatório.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#C44C30',
                    allowOutsideClick: false,
                });
            } finally {
                this.loading = false;
            }
        },
        async exportarArquivo() {
            if (!this.selectedFormat || !this.filter.year) return;

            const endpoint = this.selectedFormat === 'xlsx'
                ? 'advisor-roa/download-excel'
                : 'advisor-roa/download-pdf';

            const url = `${process.env.VUE_APP_BASE_URL}${endpoint}?period=${encodeURIComponent(this.filter.year)}`;

            try {
                const response = await this.$axios.get(url, { responseType: 'blob'});

                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const downloadUrl = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `ROA.${this.selectedFormat}`);

                const formattedPeriod = this.filter.year
                .normalize("NFD")                       // Decompõe os acentos (ex: "ç" -> "c")
                .replace(/de/g, '')                     // Remove "de"
                .replace(/ /g, '_')                     // Espaços por "_"
                .replace(/[^\w_]/g, '')                 // Remove caracteres especiais
                .replace(/_+/g, '_')                    // Substitui vários "_" por um só
                .trim();

                link.setAttribute('download', `ROA_${formattedPeriod}.${this.selectedFormat}`);

                document.body.appendChild(link);
                link.click();
                link.remove();

                this.showExportModal = false;
            } catch (error) {
                console.error('Erro na exportação:', error);
                this.$swal({
                    title: 'Erro',
                    text: 'Não foi possível exportar o arquivo.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#C44C30',
                    allowOutsideClick: false,
                });
            }
        },
        formatDecimal(value) {
            if (value == null || isNaN(value)) return '-';
            return Number(value).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
    },
    watch: {
        'filter.year': function () {
            this.search()
        }
    }
}
</script>

<style>
.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff !important;
    border-color: #28A745 !important;
    background-color: #28A745 !important;
    box-shadow: none !important;
}

.custom-control-input:not(checked) ~ .custom-control-label::before {
    border-color: #CCC !important;
    box-shadow: none !important;
}

tr:nth-child(odd) {
    background-color: #DDD !important;
}
</style>
